import { Sangha, SanghaType } from "@app/shared/types";
import { Button, ButtonProps } from "@mui/material";
import { analyticsTrack } from "app/analytics/track";
import { routes } from "app/routes";
import makeStyles from "@mui/styles/makeStyles";
import { isUserInSetupFlow } from "features/signup/signupHelpers";
import { useHistory, useLocation } from "react-router";

const useStyles = makeStyles((theme) => ({
    joinGroupButton: {
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
}));

export const JoinInterestGroupButton = (props: ButtonProps & { interestGroup: Sangha }) => {
    const { interestGroup, ...buttonProps } = props;
    const history = useHistory();
    const groupIsFull = interestGroup.availableSpots <= 0;
    const classes = useStyles();

    const location = useLocation();
    const isSetupFlow = isUserInSetupFlow(location);

    return (
        <Button
            {...buttonProps}
            variant={props.variant}
            size="small"
            disabled={groupIsFull}
            className={classes.joinGroupButton}
            onClick={() => {
                analyticsTrack("Button Clicked", {
                    label: "Join",
                    id: interestGroup.id,
                    type: SanghaType.InterestGroup,
                    location: "AllInterestGroups",
                });
                history.push(routes.memberAddInterestGroup(interestGroup.id));
            }}
        >
            {groupIsFull ? "Group is full" : "Join group"}
        </Button>
    );
};
